<template>
    <div class="wizard__wrap">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">
                    {{ agencyName }}
                </div>
            </div>

            <div class="wizard__block-dealname">
                {{ deal_name }}
            </div>

            <div class="wizard_sale_wrap row">
                <div
                    class="col-xl-12 col-lg-12 col-md-12 wizard_sale_controls wizard_sale_controls--later"
                    style="border-right: none"
                >
                    <div class="row jus-c--space-between">
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div class="form-field form-field--text">
                                <label for="sow_title"
                                    >Title<span class="red">*</span></label
                                >
                                <input
                                    type="text"
                                    id="sow_title"
                                    v-model="new_sow.title"
                                    name="sow_title"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.title"
                                    >{{ errors.title }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="datepicker"
                            >
                                <label for="sow_date"
                                    >Activation date<span class="red"
                                        >*</span
                                    ></label
                                >
                                <input
                                    type="text"
                                    id="sow_date"
                                    v-model="new_sow.date"
                                    name="sow_date"
                                    @changeDate="onChangeDatePicker"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.date"
                                    >{{ errors.date }}</span
                                >
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row jus-c--space-between">
                        <div class="col-xl-5 col-lg-5 col-md-5"></div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="valid_datepicker"
                            >
                                <label for="valid_date">Valid until</label>
                                <input
                                    type="text"
                                    id="valid_date"
                                    v-model="new_sow.valid_date"
                                    name="valid_date"
                                    @changeDate="onChangeValidDatePicker"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.valid_date"
                                    >{{ errors.valid_date }}</span
                                >
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row type-row">
                        <div
                            class="col-lg-12 col-md-12"
                            style="margin-bottom: 8px"
                        >
                            <div class="form-field form-field--radiobutton">
                                <input
                                    type="radio"
                                    name="is_has_signed_sow"
                                    id="is_has_signed_sow_true"
                                    :checked="is_has_signed_sow"
                                    @change="is_has_signed_sow"
                                />
                                <label for="is_has_signed_sow_true"
                                    >I have signed SOW</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div
                                class="new-sow-form row"
                                style="padding-left: 40px; margin-bottom: 24px"
                            >
                                <div
                                    class="col-xl-2 col-lg-2 col-md-2"
                                    style="padding-top: 12px"
                                >
                                    <div
                                        class="form-field form-field--radiobutton"
                                    >
                                        <input
                                            type="radio"
                                            name="is_file"
                                            id="is_file_true"
                                            :checked="
                                                is_file_option &&
                                                is_file_option !== 'later'
                                            "
                                            @change="is_file_option = true"
                                        />
                                        <label for="is_file_true">File</label>
                                    </div>
                                </div>
                                <div class="col-xl-10 col-lg-10 col-md-10">
                                    <div
                                        class="form-field form-field--file"
                                        ref="filepicker"
                                    >
                                        <input
                                            type="file"
                                            id="agreement"
                                            :disabled="!is_file_option_computed"
                                            name="agreement"
                                            hidden
                                            ref="fileInput"
                                            @input="pickFile"
                                            @change="pickFile"
                                        />
                                        <button
                                            type="button"
                                            class="btn btn--file"
                                        >
                                            File
                                            <i class="icon icon-plus"></i>
                                        </button>
                                        <span
                                            class="filename"
                                            v-if="new_sow.filename"
                                            >{{ new_sow.filename }}</span
                                        >
                                        <span
                                            class="error"
                                            style="left: 0"
                                            v-if="errors.file"
                                            >{{ errors.file }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div
                                class="row new-sow-form"
                                style="padding-left: 40px"
                            >
                                <div
                                    class="col-xl-2 col-lg-2 col-md-2"
                                    style="padding-top: 12px"
                                >
                                    <div
                                        class="form-field form-field--radiobutton"
                                    >
                                        <input
                                            type="radio"
                                            name="is_file"
                                            id="is_file_false"
                                            :checked="
                                                !is_file_option &&
                                                is_file_option !== null
                                            "
                                            @change="is_file_option = false"
                                        />
                                        <label for="is_file_false">URL</label>
                                    </div>
                                </div>
                                <div class="col-xl-10 col-lg-10 col-md-10">
                                    <div class="form-field form-field--text">
                                        <input
                                            type="text"
                                            id="sow_url"
                                            :disabled="is_file_option_computed"
                                            v-model="new_sow.url"
                                            name="sow_url"
                                        />
                                        <span
                                            class="error"
                                            style="left: 0"
                                            v-if="errors.url"
                                            >{{ errors.url }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div
                                class="row new-sow-form"
                                style="padding-left: 40px"
                            >
                                <div
                                    class="col-xl-4 col-lg-4 col-md-4"
                                    style="padding-top: 12px"
                                >
                                    <div
                                        class="form-field form-field--radiobutton"
                                    >
                                        <input
                                            type="radio"
                                            name="is_file"
                                            id="is_upload_later"
                                            :checked="
                                                is_file_option === 'later'
                                            "
                                            @change="is_file_option = 'later'"
                                        />
                                        <label for="is_upload_later"
                                            >Upload later</label
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row type-row" style="margin-bottom: 16px">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-field form-field--radiobutton">
                                <input
                                    type="radio"
                                    name="is_has_signed_sow"
                                    id="is_has_signed_sow_false"
                                    :checked="!is_has_signed_sow"
                                    @change="is_has_signed_sow = false"
                                />
                                <label for="is_has_signed_sow_false"
                                    >I don't have signed SOW. Please explain
                                    why</label
                                >
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="row" style="padding-left: 40px">
                                <div class="col-xl-12 col-lg-12 col-md-12">
                                    <div
                                        class="form-field form-field--textarea"
                                    >
                                        <label
                                            for="explanation"
                                            style="
                                                margin-bottom: 8px;
                                                display: block;
                                            "
                                            >Explanation</label
                                        >
                                        <textarea
                                            id="explanation"
                                            :disabled="is_has_signed_sow"
                                            v-model="new_sow.description"
                                            name="explanation"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button
                    type="button"
                    @click="onPrevSection"
                    class="btn btn--prev btn--white"
                >
                    Previous
                </button>
                <button
                    type="button"
                    @click="onSaveSow"
                    class="btn btn--next btn--gray"
                >
                    Next
                </button>
            </div>

            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader";

import CurrencyInput from "../../../components/CurrencyInput";
import { Datepicker } from "vanillajs-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { scrollToTop } from "../../../helpers/_scrollToTop";
import { SECTIONS } from "../consts";

export default {
    name: "Wizard_Upload_Later_SOW",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isLoading: true,
            is_has_signed_sow: true,
            deal_name: "",
            sow_id: null,
            deal_id: null,
            deal_line_item_id: null,
            service_name: "",
            is_file_option: true,
            is_upload_later: false,
            new_sow: {
                title: "",
                date: "",
                file: null,
                url: "",
                filename: "",
                valid_date: "",
                description: "",
            },
            errors: {
                title: null,
                date: null,
                valid_date: null,
                file: null,
                url: null,
                type: null,
                description: null,
            },
            totalPagesOfSOW: 1,
            currectPageOfSOW: 1,
            dealLineItemsWithouSOWs: null,
            urlRegex:
                /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
            is_from_query: false,
        };
    },
    components: {
        Treeselect,
        ClipLoader,
        CurrencyInput,
    },

    created() {
        this.getData();
    },

    mounted() {
        this.initDatePicker();
        this.initValidDatePicker();
        this.initFilePicker();
    },
    computed: {
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        isHasKickOff() {
            return this.$store.getters.getIsHasKickOff;
        },
        is_file_option_computed() {
            if (this.is_has_signed_sow) {
                if (this.is_file_option) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        sowIndex() {
            return this.$store.getters.getCurrentIndexSOW;
        },

        getInitParamsFromQuery() {
            return this.$store.getters.getInitUploadLaterSOWFromQuery;
        },
    },
    methods: {
        onNextPage() {
            if (this.is_from_query) {
                this.onChangeSection(
                    SECTIONS.THANK_YOU_UPLOAD_SOW,
                    SECTIONS.UPLOAD_LATER_SOW
                );
                return;
            }

            if (this.currectPageOfSOW === this.totalPagesOfSOW) {
                if (this.isHasKickOff) {
                    this.onChangeSection(
                        SECTIONS.EDIT_KICK_OFF_LINE_ITEM,
                        SECTIONS.UPLOAD_LATER_SOW
                    );
                    return;
                }

                this.onChangeSection(
                    SECTIONS.EDIT_SALE_LINE_ITEM,
                    SECTIONS.EDIT_KICK_OFF_LINE_ITEM
                );
                return;
            }

            this.setCurrentLineItem(this.currectPageOfSOW + 1);
            this.currectPageOfSOW = this.currectPageOfSOW + 1;

            this.$nextTick(() => {
                scrollToTop(); // Прокрутка вверх
            });
        },
        onPrevSection() {
            if (this.currentPageKickOff === 1) {
                this.onChangeSection(
                    SECTIONS.DASHBOARD,
                    SECTIONS.UPLOAD_LATER_SOW
                );
                return;
            }

            this.setCurrentLineItem(this.currectPageOfSOW - 1);
            this.currectPageOfSOW = this.currectPageOfSOW - 1;

            this.$nextTick(() => {
                scrollToTop(); // Прокрутка вверх
            });
        },
        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.new_sow.date = date;
            }
        },
        onChangeValidDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.new_sow.valid_date = date;
            }
        },
        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },
        initValidDatePicker() {
            const node__datepicker = this.$refs.valid_datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },
        initFilePicker() {
            const inputField = this.$refs.filepicker;

            if (!inputField) {
                return;
            }

            const button = inputField.querySelector("button");
            const input = inputField.querySelector("input");
            const filenameNode = inputField.querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    this.new_sow.filename = filename;
                    //filenameNode.innerHTML = filename;
                    this.new_sow.file = file[0];
                }
            });
        },
        pickFile() {
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(file[0]);
                this.new_sow.file = file[0];
            }
        },
        setCurrentLineItem(index) {
            if (this.dealLineItemsWithouSOWs.length > 0) {
                const dealLineItems = this.dealLineItemsWithouSOWs;
                console.log("dealLineItems", dealLineItems);
                this.deal_id = dealLineItems[index - 1].deal.id;
                this.sow_id = dealLineItems[index - 1].id;
                this.deal_name = dealLineItems[index - 1].deal.name;
                this.new_sow.title = dealLineItems[index - 1].name;
                this.new_sow.date = dealLineItems[index - 1].date;
                this.new_sow.valid_date = dealLineItems[index - 1].valid_date;
            }
        },

        checkIfHaveDealLineItems(is_update = false) {
            if (this.dealLineItemsWithouSOWs.length > 0) {
                this.totalPagesOfSOW = this.dealLineItemsWithouSOWs.length;
                this.setCurrentLineItem(1);
            } else {
                if (this.isHasKickOff) {
                    this.onChangeSection(
                        SECTIONS.EDIT_KICK_OFF_LINE_ITEM,
                        SECTIONS.UPLOAD_LATER_SOW
                    );
                } else {
                    this.onChangeSection(
                        SECTIONS.EDIT_SALE_LINE_ITEM,
                        SECTIONS.UPLOAD_LATER_SOW
                    );
                }
            }
        },

        transformObjectToArray(obj) {
            return Object.values(obj).flatMap((row) =>
                Object.values(row["data"])
            );
        },

        async getData(is_update = false) {
            this.isLoading = true;

            await axios
                .post("/api/wizard/getList", {
                    page: "get_upload_later",
                })
                .then((res) => {
                    this.dealLineItemsWithouSOWs = this.transformObjectToArray(
                        Object.values(res.data.page)
                    );

                    if (this.getInitParamsFromQuery) {
                        if (this.getInitParamsFromQuery) {
                            const { sow_id } = this.getInitParamsFromQuery;

                            if (!sow_id) {
                                this.$toast.error("Not found deal");
                                return;
                            }

                            this.is_from_query = true;

                            const sow_data = this.dealLineItemsWithouSOWs.find(
                                (dli) => dli.id === Number(sow_id)
                            );
                            if (sow_data) {
                                this.deal_id = sow_data.deal.id;
                                this.deal_name = sow_data.deal.name;
                                this.sow_id = sow_data.id;
                                this.new_sow.title = sow_data.name || "";
                                this.new_sow.date = sow_data.date || null;
                                this.new_sow.valid_date =
                                    sow_data.valid_date || null;
                            }

                            if (!sow_data) {
                                this.onChangeSection(
                                    SECTIONS.THANK_YOU_UPLOAD_SOW,
                                    SECTIONS.UPLOAD_LATER_SOW
                                );
                            }
                        }
                        return;
                    }

                    this.checkIfHaveDealLineItems();
                    this.$nextTick(() => {
                        scrollToTop(); // Прокрутка вверх
                    });
                })
                .catch((err) => {
                    console.log("err getData upsell", err);
                    this.onChangeSection(
                        SECTIONS.DASHBOARD,
                        SECTIONS.UPLOAD_LATER_SOW
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        validateFields() {
            this.errors.date = null;
            this.errors.title = null;
            this.errors.file = null;
            this.errors.type = null;
            this.errors.url = null;
            this.errors.valid_date = null;

            if (!this.new_sow.title) {
                this.errors.title = "Required";
            }

            if (!this.new_sow.date) {
                this.errors.date = "Required";
            }

            if (
                this.is_file_option &&
                !this.new_sow.file &&
                this.is_has_signed_sow
            ) {
                this.errors.file = "Required";
            }

            if (
                !this.is_file_option &&
                !this.new_sow.url &&
                this.is_has_signed_sow
            ) {
                this.errors.url = "Required";
            }
            if (
                this.is_has_signed_sow &&
                !this.is_file_option &&
                this.new_sow.url &&
                !this.urlRegex.test(this.new_sow.url)
            ) {
                this.errors.url = "Invalid URL";
            }
            if (
                this.new_sow.date &&
                this.new_sow.valid_date &&
                new Date(this.new_sow.date) > new Date(this.new_sow.valid_date)
            ) {
                this.errors.valid_date = "Invalid valid date";
            }
            if (
                !this.is_has_signed_sow &&
                this.new_sow.description.length < 5
            ) {
                this.errors.description = "Required";
            }
        },

        async onSaveSow() {
            if (this.is_file_option === "later") this.onNextPage();

            try {
                this.validateFields();

                if (
                    this.is_has_signed_sow &&
                    (this.errors.date ||
                        this.errors.file ||
                        this.errors.type ||
                        this.errors.url ||
                        this.errors.valid_date)
                ) {
                    return;
                }

                if (
                    !this.is_has_signed_sow &&
                    (this.errors.title ||
                        this.errors.date ||
                        this.errors.valid_date)
                ) {
                    return;
                }
                this.isLoading = true;
                const formData = new FormData();

                formData.append("name", this.new_sow.title);
                formData.append("id", this.sow_id);
                formData.append("deal_id", this.deal_id);
                formData.append(
                    "file",
                    this.new_sow.file === null ? "" : this.new_sow.file
                );
                formData.append(
                    "date",
                    this.new_sow.date === null ? "" : this.new_sow.date
                );
                formData.append(
                    "valid_date",
                    this.new_sow.valid_date === null
                        ? ""
                        : this.new_sow.valid_date
                );
                formData.append("description", this.new_sow.description);
                formData.append(
                    "url",
                    this.new_sow.url ? this.new_sow.url : ""
                );
                formData.append(
                    "type",
                    this.is_has_signed_sow
                        ? this.is_file_option
                            ? "file"
                            : "url"
                        : "none"
                );

                await axios
                    .post("/deals/sow/update", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then(() => {
                        this.onNextPage();
                    })
                    .catch((err) => {
                        this.$toast.error("Something went wrong!");
                        console.log("ERROR addSOWFile", err);
                    })
                    .finally(() => (this.isLoading = false));
            } catch (err) {
                console.error("Error in UploadLater.vue - onSaveSow", err);
            }
        },

        onSetUploadLater() {
            this.is_file_option = null;
            this.is_upload_later = true;
        },
    },
};
</script>
